import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const defaultProps = {
  title: null,
  description: null,
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        siteUrl: url
        twitterUsername
        logo
      }
    }
  }
`;

type Props = {
  title?: string;
  description?: string;
};

const Seo = (props: Props): JSX.Element => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const { site } = useStaticQuery(query);
  const currentLang = i18n.language;
  const updatedProps = {
    ...defaultProps,
    ...props,
  };

  const { defaultTitle, titleTemplate, siteUrl, twitterUsername, logo } =
    site.siteMetadata;
  const seo = {
    title: updatedProps.title || defaultTitle,
    description: updatedProps.description
      ? updatedProps.description
      : t('seo.defaultDescription'),
    url: `${siteUrl}${pathname}`,
  };

  return (
    <Helmet
      title={seo.title}
      titleTemplate={seo.title !== defaultTitle ? titleTemplate : ''}
      bodyAttributes={{ class: 'h-100' }}
      htmlAttributes={{ class: 'h-100', lang: currentLang }}
    >
      <meta
        name="keywords"
        content="Bitcoin, Ethereum, LTC, BNB, Binance, Bitfinex, KuCoin, Crypto, Blockchain, Trading Bitcoin, DCA"
      />
      <meta name="description" content={seo.description as string} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Whalinvest" />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      <meta property="twitter:title" content={seo.title} />
      <meta property="twitter:image" content={logo} />
      <meta property="twitter:image:src" content={logo} />
      <meta property="twitter:site" content="Whalinvest" />
      <meta property="twitter:card" content="summary_large_image" />
      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      <meta property="og:image" content={logo} />
    </Helmet>
  );
};

export default Seo;
